import { useState } from 'react';
import cx from 'classnames';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ExportOutlined, MailOutlined } from '@ant-design/icons';

import { SvgIcon } from '@/components/SvgIcon';
import { externalLinks } from '@/config';
import { useDevice } from '@/hooks';

import styles from './HelpMenu.module.sass';

const HelpMenu = () => {
  const [isActive, setIsActive] = useState(false);
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const menuItems: MenuProps['items'] = [
    {
      key: 'contact',
      label: (
        <Link className={styles.option} to="/contact">
          <MailOutlined />
          {t('translation.contact_link')}
        </Link>
      ),
    },
    {
      key: 'terms',
      label: (
        <a
          className={styles.option}
          href="/documents/terms.pdf"
          target="_blank"
        >
          <ExportOutlined />
          {t('translation.service_terms_title')}
        </a>
      ),
    },
    {
      key: 'privacy',
      label: (
        <a
          className={styles.option}
          href={externalLinks.SERVICE_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExportOutlined />
          {t('translation.privacy_policy2')}
        </a>
      ),
    },
    {
      key: 'risks',
      label: (
        <a
          className={styles.option}
          href={externalLinks.RISKS_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExportOutlined />
          {t('translation.risks_link', { app_title: 'AMLBot' })}
        </a>
      ),
    },
    {
      key: 'support',
      label: (
        <a
          className={styles.option}
          href={externalLinks.TELEGRAM_SUPPORT_BOT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <SvgIcon name="telegram" />
          {t('translation.tm_support_link')}
        </a>
      ),
    },
  ];

  const classes = cx(styles.button, {
    [styles['is-active']]: isActive,
  });

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement={isMobile ? 'bottomCenter' : 'bottomRight'}
      arrow={{ pointAtCenter: true }}
      onOpenChange={setIsActive}
    >
      <button type="button" className={classes}>
        <SvgIcon name="question-circle" />
      </button>
    </Dropdown>
  );
};

export default HelpMenu;
